<form class="filter" #formElement [formGroup]="form">

    <mat-form-field class="full-width">
        <input matInput autocomplete="off" formControlName="number" placeholder="Nùmero">
        <mat-error *ngIf="f.number.errors && f.number.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>


    <mat-form-field class="full-width">
        <input type="text" #client matInput placeholder="Médico" formControlName="physician" [matAutocomplete]="autPhysician">
        <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysician.displayFn">
            <mat-option *ngFor="let physician of filteredPhysicianOptions | async" [value]="physician">
                {{ physician.Name }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.physician.errors && f.physician.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>
</form>